import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InfoTooltipComponent } from '@ui-kit/miscs/info-tooltip/info-tooltip.component';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
    selector: 'checkbox',
    standalone: true,
    imports: [CheckboxModule, FormsModule, TranslateModule, InfoTooltipComponent],
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent {
    id = input.required<string>();
    value = model.required<boolean>();

    label = input<string>('');
    tooltipText = input<string>('');

    disabled = input<boolean>(false);
    required = input<boolean>(false);
    binary = input<boolean>(true);
    readonly = input<boolean>(false);
    size = input<'small' | 'large'>('large');

    flexStartAlignment = input<boolean>(false);
    centerAlignment = input<boolean>(false);
    boldLabel = input<boolean>(false);
    class = input<string>('');

    onChange = output<boolean>();
}
